import "./FormElement.css.ts.vanilla.js";
var t = "kpid2t1", a = "kpid2t2", i = "kpid2t3", e = "kpid2t4", d = "kpid2t5", p = "kpid2t6", n = "kpid2ta", o = "kpid2tb", k = "kpid2tc", s = "kpid2t0", v = "kpid2t7", c = "kpid2t9", g = "kpid2t8";
export {
  t as alignBottom,
  a as alignCenter,
  i as alignLeft,
  e as alignMiddle,
  d as alignRight,
  p as alignTop,
  n as errorContainer,
  o as errorMessageHeader,
  k as errorMessagePrefix,
  s as formElement,
  v as successButton,
  c as successButtonIcon,
  g as successIcon
};
